import { render, staticRenderFns } from "./_StationDetailsContent.vue?vue&type=template&id=84f4b49a&scoped=true&"
import script from "./_StationDetailsContent.vue?vue&type=script&lang=js&"
export * from "./_StationDetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./_StationDetailsContent.vue?vue&type=style&index=0&id=84f4b49a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f4b49a",
  null
  
)

export default component.exports